<div class="modal-content modal-milvus">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-title-default">
        {{ "SELECIONE_CLIENTE" | translate }}
      </h6>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="close()"
      >
        <i class="mdi mdi-close"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div *ngFor="let cliente of clientes; let i = index" class="col-12">
            <label class="radio-box">
                <div class="col d-flex justify-content-start">
                    <input type="radio" name="padrao_todos" id="" [(ngModel)]="clienteSelecionado" [value]="cliente" />
                    <span class="checkmark"></span>
                </div>
            </label>
            <label>{{cliente.descricao}}</label>
        </div>
      </div>
    </div>
    <div class="modal-footer modal-footer-milvus">
        <button class="btn badge-pill btn-mv-primary" (click)="iniciarConversa()">
            <span [translate]="'INICIAR_CONVERSA'"></span>
        </button>
    </div>
  </div>
  